export enum URIPrefix {
  STATE = 'sta',
  CITY = 'cty',
  INSURANCE = 'ins',
  MODALITY = 'mod',
  SPECIALTY = 'spc',
  GENDER = 'gdr',
}
